import React from "react";
import { ExternalDirectiveResearch } from "./ExternalDirectiveResearch";

export const RohsResearch = () => (
  <ExternalDirectiveResearch
    eurLexUrl="https://eur-lex.europa.eu/eli/dir/2011/65/oj"
    i18nPrefix="steps.questionaire.rohs.research"
  />
);
